import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=05d93fcf&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=05d93fcf&scoped=true&lang=css&"
import style1 from "./wallet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d93fcf",
  null
  
)

export default component.exports